import querystring from 'querystring'
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest`

export default {
  getNumberTileData(listId, measures, searchAndFilterParams) {
    const params = {
      measures,
    }

    const allParams = this._getCleanParameters({ ...params, ...searchAndFilterParams })

    return ApiService.get(
      `${resourceUrl}/data/numberTile/${listId}?${querystring.stringify(allParams)}`,
    )
  },
  getWordCloudData(listId, wordCloudColumns, limit, exclude, searchAndFilterParams) {
    const params = {
      wordCloudColumns,
      limit,
      exclude,
    }

    const allParams = this._getCleanParameters({ ...params, ...searchAndFilterParams })

    return ApiService.get(
      `${resourceUrl}/data/wordCloud/${listId}?${querystring.stringify(allParams)}`,
    )
  },
  getMapData(listId, latitude, longitude, location, measures, searchAndFilterParams) {
    const params = {
      latitude,
      longitude,
      location,
      measures,
    }

    const allParams = this._getCleanParameters({ ...params, ...searchAndFilterParams })

    return ApiService.get(`${resourceUrl}/data/map/${listId}?${querystring.stringify(allParams)}`)
  },
  getCategories(listIds) {
    const listId = listIds.listId
    let query = ''
    if (listIds.userListViewId) {
      query = `?userListViewId=${listIds.userListViewId}`
    }
    return ApiService.get(`${resourceUrl}/data/chartCategory/${listId}${query}`)
  },
  getColorPalette() {
    return ApiService.get(`${resourceUrl}/data/chartColorPalette`)
  },
  getChartData(
    listId,
    category,
    dateFormat,
    level,
    measures,
    calculatedMeasures,
    series,
    serieslevel,
    searchAndFilterParams,
    isFillMissingDates,
    groupAsOne,
  ) {
    const params = {
      category,
      dateFormat,
      level,
      measures,
      calculatedMeasures,
      series,
      serieslevel,
      isFillMissingDates,
      groupAsOne,
    }

    const allParams = this._getCleanParameters({ ...params, ...searchAndFilterParams })
    const chartDataUrl = `${resourceUrl}/data/chart/${listId}?${querystring.stringify(allParams)}`
    return ApiService.get(chartDataUrl)
  },
  persistChartParameters(chartParameters) {
    const url = `${resourceUrl}/data/visualization/create`
    return ApiService.post(url, chartParameters)
  },
  _getCleanParameters(allParams) {
    Object.keys(allParams).forEach((key) => allParams[key] == null && delete allParams[key])
    return allParams
  },
}
